/** Purāṇa collection tiles — route to dedicated library pages (not SacredTopicPage). */

export const PURANA_TILES = [
  {
    id: "markandeya-puranam",
    title: "Markandeya Puranam",
    summary:
      "Eternal youth, Devī Māhātmyam, and cosmic vision — stories from the Mārkaṇḍeya Purāṇa.",
    path: "/library/markandeya-puranam",
    image_url: "/images/sacred-library/stories/markandeya.svg",
  },
];

export function getPuranaTile(id) {
  return PURANA_TILES.find((p) => p.id === id) ?? null;
}

export function puranaPath(id) {
  const tile = getPuranaTile(id);
  return tile?.path ?? `/library/${id}`;
}
